@if (label) {
  <span
    class="carrier-select-label form-control-label"
    [class.required]="required()"
  >
    {{ label }}
  </span>
}
@if (carrierList) {
  <p-select
    appendTo="body"
    (onChange)="onCarrierChange($event)"
    [options]="carrierList"
    [(ngModel)]="carrier"
    [placeholder]="
      carrier?.getName() || (required() ? 'Please select carrier' : 'All')
    "
    [filter]="true"
    filterBy="label, value"
    [disabled]="disabled()"
    [required]="required()"
  >
  </p-select>
}
